import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { loadAppFonts } from "./theme/tokens";
import "./theme/global.css";

loadAppFonts();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
